import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import { TermsPage, PrivacyPage, SupportPage } from './pages/LegalPage';
import ConditionPage from './pages/ConditionPage';
import reportWebVitals from './reportWebVitals';
import "./i18n";

// Split out the routes nothing else needs. src/data/blogPosts.js is 298KB of
// article text — importing BlogIndex/BlogPost up here shipped all of it to every
// visitor who opened the homepage, and the homepage never reads it. AdminDashboard
// is the same story (and drags react-icons/md along) for a page only one person opens.
//
// The homepage and the condition pages stay EAGER on purpose: they are prerendered
// for search engines, and a lazy chunk would put a blank Suspense gap in front of
// exactly the pages that must paint fastest.
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const BlogIndex = lazy(() => import('./pages/BlogIndex'));
const BlogPost = lazy(() => import('./pages/BlogPost'));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <HelmetProvider>
            <BrowserRouter>
                <Suspense fallback={null}>
                    <Routes>
                        <Route path="/admin" element={<AdminDashboard />} />
                        <Route path="/terms" element={<TermsPage />} />
                        <Route path="/privacy" element={<PrivacyPage />} />
                        <Route path="/support" element={<SupportPage />} />
                        <Route path="/psoriasis" element={<ConditionPage slug="psoriasis" />} />
                        <Route path="/eczema" element={<ConditionPage slug="eczema" />} />
                        <Route path="/acne" element={<ConditionPage slug="acne" />} />
                        <Route path="/rosacea" element={<ConditionPage slug="rosacea" />} />
                        <Route path="/vitiligo" element={<ConditionPage slug="vitiligo" />} />
                        <Route path="/hidradenitis" element={<ConditionPage slug="hidradenitis" />} />
                        <Route path="/alopecia" element={<ConditionPage slug="alopecia" />} />
                        <Route path="/urticaria" element={<ConditionPage slug="urticaria" />} />
                        <Route path="/perioral-dermatitis" element={<ConditionPage slug="perioral-dermatitis" />} />
                        <Route path="/seborrheic-dermatitis" element={<ConditionPage slug="seborrheic-dermatitis" />} />
                        <Route path="/prurigo-nodularis" element={<ConditionPage slug="prurigo-nodularis" />} />
                        <Route path="/blog" element={<BlogIndex />} />
                        <Route path="/blog/:slug" element={<BlogPost />} />
                        <Route path="*" element={<App />} />
                    </Routes>
                </Suspense>
            </BrowserRouter>
        </HelmetProvider>
    </React.StrictMode>
);

reportWebVitals();
